'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Sticky = require('./Sticky');

var _Sticky2 = _interopRequireDefault(_Sticky);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Sticky2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/dist/commonjs/modules/Sticky/index.js
 ** module id = 3911
 ** module chunks = 0
 **/